import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './reset-impact-analysis-dialog.controller';
import template from './reset-impact-analysis-dialog.html';


class dialogService {
  getOptions($event, { processes, assessmentId }) {
    return {
      controller,
      controllerAs: 'resetImpactAnalysisDialogVM',
      locals: {
        processes,
        assessmentId
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.resetImpactAnalysisDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('resetImpactAnalysisDialog', dialogService)
  .name;
